import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { adminResetPassword, partnerResetPassword } from '../../api/auth';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ViewIcon from '../../utils/media/icons/view_icon.png';

const ResetPassword = () => {

    const authState = useSelector(state => state.auth);
    
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');

    const [passwordError, setPasswordError] = useState('');
    const [confirmPasswordError, setConfirmPasswordError] = useState('');

    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    
    const validatePassword = (password) => {
        const passwordRegex = /^(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
        return passwordRegex.test(password);
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        setPasswordError('');
        setConfirmPasswordError('');

        let isValid = true;
        // Password validation
        if (password === '') {
            setPasswordError('Password is required.');
            isValid = false;
        } else if (!validatePassword(password)) {
            setPasswordError(
                'Password must be at least 8 characters long, include at least one uppercase letter, one number, and one special character.'
            );
            isValid = false;
        }
        // Confirm Password validation
        if (confirmPassword === '') {
            setConfirmPasswordError('Password is required.');
            isValid = false;
        } else if (!validatePassword(confirmPassword)) {
            setConfirmPasswordError(
                'Password must be at least 8 characters long, include at least one uppercase letter, one number, and one special character.'
            );
            isValid = false;
        }

        if (isValid) {
            partnerResetPassword({ email: authState.email, password, confirmPassword, otp: authState.otp }, dispatch, navigate, toast);
        }
    };

    return (
        <div className='w-screen h-screen flex justify-between items-center p-5 gap-5'>
            <div className='h-full basis-1/2 rounded-3xl py-5 flex flex-col items-center bg-[radial-gradient(_109.97%_217.38%_at_0%_0%,_#f2fff7_0%,_#a1fbc0_68.68%,_#81f7a9_100%_)]'>
                <div className='place-self-start flex justify-start items-center'>
                    <img src={require('../../utils/media/logo.png')} alt="climate crusaders" className='h-16' />
                    <h1 className='text-primary font-extrabold text-lg'>Climate Crusaders</h1>
                </div>
                <div className='h-full flex justify-center items-center'>
                    <img src={require('../../utils/media/login_page.png')} className='place-self-center' alt="" />
                </div>
            </div>
            <div className='rounded-3xl shadow-lg basis-1/2 flex flex-col justify-start items-center py-20 px-14'>
                <h1 className='text-primary text-4xl font-semibold'>Reset Password</h1>
                <form action="" method='post' className='w-full my-10 flex flex-col'>
                    <div className="email flex flex-col w-full">
                        <span className={`${passwordError ? 'text-red' : 'text-black'} font-bold text-base`}>New Password</span>
                        <div className='w-full relative'>
                            <input
                                type={showPassword ? "text" : "password"}
                                name="password"
                                id="password"
                                required
                                placeholder='Enter New Password'
                                className={`border ${passwordError ? 'border-red' : 'border-secondary'} rounded-md px-3 py-2 outline-primary w-full`}
                                value={password}
                                onChange={e => setPassword(e.target.value)}
                            />
                            <button className="absolute right-1 top-2 rounded p-1.5 bg-[rgba(52,199,89,0.1)] hover:bg-[rgba(52,199,89,0.2)] mx-1 min-h-7 max-w-8" onClick={() => setShowPassword(!showPassword)} type='button'>
                                <img src={ViewIcon} alt="view" />
                            </button>
                        </div>
                        {
                            passwordError &&
                            <p className={`${passwordError ? 'text-red' : 'text-black'} text-base`}>{passwordError}</p>
                        }
                    </div>
                    <div className="password flex flex-col w-full mt-5">
                        <span className={`${passwordError ? 'text-red' : 'text-black'} font-bold text-base`}>Confirm Password</span>
                        <div className='w-full relative'>
                            <input
                                type={showConfirmPassword ? "text" : "password"}
                                name="confirmPassword"
                                id="confirmPassword"
                                required
                                placeholder='Confirm New Password'
                                className={`border ${confirmPasswordError ? 'border-red' : 'border-secondary'} rounded-md px-3 py-2 outline-primary w-full`}
                                value={confirmPassword}
                                onChange={e => setConfirmPassword(e.target.value)}
                            />
                            <button className="absolute right-1 top-2 rounded p-1.5 bg-[rgba(52,199,89,0.1)] hover:bg-[rgba(52,199,89,0.2)] mx-1 min-h-7 max-w-8" onClick={() => setShowConfirmPassword(!showConfirmPassword)} type='button'>
                                <img src={ViewIcon} alt="view" />
                            </button>
                        </div>
                        {
                            confirmPasswordError &&
                            <p className={`${confirmPasswordError ? 'text-red' : 'text-black'} text-base`}>{confirmPasswordError}</p>
                        }
                    </div>
                    <button className='bg-primary self-end text-base px-20 py-2 text-white font-bold mt-10 max-w-56 rounded-md border hover:bg-white hover:border hover:text-primary' onClick={handleSubmit}>
                        Submit
                    </button>
                </form>
            </div>
            <ToastContainer 
                position = "bottom-right"
            />
        </div>
    )
}

export default ResetPassword;